import VueRouter from 'vue-router';
import Weight from './components/Weight';
import Height from './components/Height';
import Gender from './components/Gender';
import DietSelection from './components/DietSelection';
import Taralyn from './components/Taralyn';
import Miranda from './components/Miranda';
import MotivationScience from './components/MotivationScience';
import NextSteps from './components/NextSteps';
import PaidOut from './components/PaidOut';
import TopRatedApps from './components/TopRatedApps';
import Calculating from './components/Calculating';
import Signup from './components/Signup';
import Age from './components/Age';
import Attract from './components/Attract';
import WeightLossProgramTried3 from './components/WeightLossProgramTried3';
import WeightHistory from './components/WeightHistory';
import PastChallenges from './components/PastChallenges';
import GLP1 from './components/GLP1';
import PhysicalActivity from './components/PhysicalActivity';
import Sleep from './components/Sleep';
import { DELAY_TRANSITION_MS_DEFAULT } from './contants';

const ROOT_PATH = '/';

// map a component name with a url path
const ROUTE_NAMES = {
  Gender: '/3gender',
  Height: '/2height',
  Weight: '/1weight',
  Age: '/age',
  Attract: '/attract',
  MotivationScience: '/11science',
  WeightLossProgramTried3: '/9.1programtried',
  WeightHistory: '/weighthistory',
  Miranda: '/12miranda',
  PastChallenges: '/pastchallenges',
  GLP1: '/glp1',
  Taralyn: '/14taralyn',
  PhysicalActivity: '/physicalactivity',
  Sleep: '/sleep',
  DietSelection: '/13dietstick',
  NextSteps: '/16nextsteps',
  PaidOut: '/17catch',
  TopRatedApps: '/18reputation',
  Calculating: '/19calculating',
  Signup: '/20signup'
}

// routes have to be ordered by the position they appear in order to calculate progress value on the progress bar
const routes = [
  { path: ROOT_PATH, component: Gender },
  { path: ROUTE_NAMES.Gender, component: Gender },
  { path: ROUTE_NAMES.Height, component: Height },
  { path: ROUTE_NAMES.Weight, component: Weight },
  { path: ROUTE_NAMES.Age, component: Age },
  { path: ROUTE_NAMES.Attract, component: Attract },
  { path: ROUTE_NAMES.MotivationScience, component: MotivationScience },
  { path: ROUTE_NAMES.WeightLossProgramTried3, component: WeightLossProgramTried3 },
  { path: ROUTE_NAMES.WeightHistory, component: WeightHistory },
  { path: ROUTE_NAMES.Miranda, component: Miranda },
  { path: ROUTE_NAMES.PastChallenges, component: PastChallenges },
  { path: ROUTE_NAMES.GLP1, component: GLP1 },
  { path: ROUTE_NAMES.Taralyn, component: Taralyn },
  { path: ROUTE_NAMES.PhysicalActivity, component: PhysicalActivity },
  { path: ROUTE_NAMES.Sleep, component: Sleep },
  { path: ROUTE_NAMES.DietSelection, component: DietSelection },
  { path: ROUTE_NAMES.NextSteps, component: NextSteps },
  { path: ROUTE_NAMES.PaidOut, component: PaidOut },
  { path: ROUTE_NAMES.TopRatedApps, component: TopRatedApps },
  { path: ROUTE_NAMES.Calculating, component: Calculating },
  { path: ROUTE_NAMES.Signup, component: Signup }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});

function delayedTransition(router, path, ms = DELAY_TRANSITION_MS_DEFAULT) {
  setTimeout(function () {
    router.push({ path }, () => {})
  }, ms);
}

function navigateTo(router, path) {
  router.push(path, () => {})
}

export { ROUTE_NAMES, router, delayedTransition, navigateTo };
